"use strict";

exports.__esModule = true;
exports.default = void 0;
var _locale = require("../../lib/locale");
var _default = exports.default = {
  methods: {
    t(...args) {
      return _locale.t.apply(this, args);
    }
  }
};